import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { getLocalizedLink } from './tool';
import i10n from '../i10n';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faHome, faSquareArrowUpRight} from '@fortawesome/free-solid-svg-icons';
import {GoogleAds} from "./googleAds";
import {steps} from "../../constants/steps";
import {UserHelper} from "../helpers/userHelper";
import {AsyncSVG} from "./AsyncSVG";
import sitemap from "../sitemap";
import config from "../../config";

export const ToolStatus = {
    None: 0,
    Highlight: 1,
    New: 2,
    ComingSoon: 3,
    Hidden: 4,
    Beta: 5
}


class PdfToolHeaderComponent extends PureComponent {

    render() {
        var toolLabel = i10n.getToolLabels(this.props.tool);
        return (
            <div>
                <div className="row align-items-center no-gutters ave-breadcrumbs" >
                    <div className="col-auto">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link aria-label="Go back" to={getLocalizedLink('')}>
                                        <FontAwesomeIcon icon={faHome} /> {i10n._LAYOUT_BREADCRUMB_HOME}
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">{toolLabel.title}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div id="avelyn-ads-banner" className="jumbotron">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-1 col-md-2 col-sm-12" style={{ padding: 0 }}><AsyncSVG src="/images/avelyn-ai-star.svg" /></div>
                            <div className="col-lg-8 col-md-6 col-sm-12">
                                <div className="row title">
                                    {i10n._VIEW_LAYOUT_AVELYN_TITLE}
                                </div>
                                <div className="row">
                                    {i10n._VIEW_LAYOUT_AVELYN_SUBTITILE}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-12" style={{ margin: '5px 0', padding: 0 }}>
                                    <a href={sitemap.AVELYN_HOME} target="_blank" className="btn btn-black float-left float-md-right goto-btn">
                                        {i10n._VIEW_LAYOUT_AVELYN_TRY_FREE}
                                        <FontAwesomeIcon  className="ml-2" icon={faSquareArrowUpRight} />
                                    </a>
                            </div>
                        </div>
                    </div>
                </div>
                <GoogleAds  display={UserHelper.IsUsingPaidPlan() === false && this.props.step === steps.success && !config.disableGoogleAds } />
                <div className="row align-items-center justify-content-center no-gutters mt-5 mb-2" >
                    <div className="col-auto">
                        <div className="header-icon">
                            <img width="65" height="65" alt="Tool Icon" className={`tool-small-img rounded-icon ${this.props.tool.fillClassName}`} src={this.props.tool.image} />
                        </div>
                    </div>
                    <div className="col-auto tool-header-container">
                        <div>
                            <h1 className="tool-header">{toolLabel.title}</h1>
                            {
                                this.props.tool.status ===  ToolStatus.Beta &&
                                <div className="tool-label bg-danger">
                                    <p>{i10n._VIEW_LAYOUT_BETA_BADGE}</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="row align-items-center justify-content-center no-gutters mb-5" >
                    <div className="col-12">
                        <div className="text-center"><h2 className="tool-subheader">{toolLabel.subtitle}</h2></div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapState = ({ tool }) => {
    return {
        language: tool.lang,
        step: tool.step
    };
}
export const PdfToolHeader = connect(mapState)(PdfToolHeaderComponent);